var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "list_page", attrs: { id: "list-center" } },
      [
        _c(
          "div",
          { staticClass: "c_channel" },
          _vm._l(_vm.channelList, function (item) {
            return _c(
              "a",
              {
                key: item.at_id,
                staticClass: "channel_item",
                class: item.at_id == _vm.currentId ? "active" : "",
                attrs: {
                  href:
                    item.at_name == "推荐"
                      ? "/marvel-list?id=" + item.at_id
                      : "/list-page?id=" + item.at_id,
                },
              },
              [_vm._v(" " + _vm._s(item.at_name) + " ")]
            )
          }),
          0
        ),
        _c("div", { staticClass: "v_list_content" }, [
          _c(
            "ul",
            { staticClass: "v_list_ul" },
            _vm._l(_vm.videoList, function (item) {
              return _c("li", { key: item.id, staticClass: "v_list_li" }, [
                _c("div", { staticClass: "v_item" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "/play-page?id=" +
                          item.id +
                          "&classify=" +
                          item.classify,
                        target: "_blank",
                      },
                    },
                    [
                      _c("img", { attrs: { src: item.img_url[0] } }),
                      _c("div", { staticClass: "v_detail" }, [
                        _c("span", { staticClass: "v_timestamp" }, [
                          _vm._v(_vm._s(item.publish_date)),
                        ]),
                        _c("span", { staticClass: "v_duration" }, [
                          _vm._v(_vm._s(item.video_duration)),
                        ]),
                      ]),
                      _c("div", { staticClass: "v_title" }, [
                        _c("h4", { staticClass: "main" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                        _c("p", {
                          staticClass: "sub",
                          domProps: { innerHTML: _vm._s(item.desc) },
                        }),
                      ]),
                    ]
                  ),
                ]),
              ])
            }),
            0
          ),
        ]),
        _c("div", { staticClass: "clear" }),
        _c("pagination", {
          attrs: {
            total: _vm.total,
            "handle-current-change": _vm.handleCurrentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }